import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import HomePage from './components/HomePage.js';
import ProfilePage from './components/ProfilePage.js';
import MyHeroesPage from './components/MyHeroesPage.js';
import KnowledgeHubPage from './components/KnowledgeHubPage.js';
import SquadTrackerPage from './components/SquadTrackerPage.js';
import RoleDeck from './components/RoleDeck.js';
import TalentPool from './components/TalentPoolPage.js';
import TalentsList from './components/TalentsList.js';
import BroadcastsList from './components/BroadcastsList.js';
import TalentProfiles from './components/TalentProfiles.js';
import ApiTest from './components/ApiTest.js';
import BroadcastFromHQ from './components/BroadcastFromHQ.js';
import Login from './components/Login.js';
import { CreditsProvider } from './components/CreditsContext.js';
import { AuthProvider, useAuth } from './contexts/AuthContext.js';
import RequireAuth from './components/RequireAuth.js';

// Component to handle root route redirection based on auth status
function RootRedirect() {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }
  
  return currentUser ? <Navigate to="/home" replace /> : <Login initialMode="login" />;
}

function App() {

  return (
    <AuthProvider>
      <HashRouter>
        <CreditsProvider initialScreening={0} initialPass={0} initialShortlistPass={0}>
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<Login initialMode="login" />} />
            <Route path="/signup" element={<Login initialMode="signup" />} />
            <Route path="/" element={<RootRedirect />} />
            
            {/* Protected Routes - Require Authentication */}
            <Route path="/home" element={
              <RequireAuth>
                <HomePage />
              </RequireAuth>
            } />
            <Route path="/profile" element={
              <RequireAuth>
                <ProfilePage />
              </RequireAuth>
            } />
            <Route path="/talent-pool" element={
              <RequireAuth>
                <TalentPool />
              </RequireAuth>
            } />
            <Route path="/my-heroes" element={
              <RequireAuth>
                <MyHeroesPage />
              </RequireAuth>
            } />
            <Route path="/knowledge-hub" element={
              <RequireAuth>
                <KnowledgeHubPage />
              </RequireAuth>
            } />
            <Route path="/squad-tracker" element={
              <RequireAuth>
                <SquadTrackerPage />
              </RequireAuth>
            } />
            <Route path="/role-deck" element={
              <RequireAuth>
                <RoleDeck />
              </RequireAuth>
            } />
            
            {/* Admin Routes - Require Authentication */}
            <Route path="/admin/talents" element={
              <RequireAuth>
                <TalentsList />
              </RequireAuth>
            } />
            <Route path="/admin/broadcasts" element={
              <RequireAuth>
                <BroadcastsList />
              </RequireAuth>
            } />
            <Route path="/admin/profiles" element={
              <RequireAuth>
                <TalentProfiles />
              </RequireAuth>
            } />
            <Route path="/admin/test" element={
              <RequireAuth>
                <ApiTest />
              </RequireAuth>
            } />
            
            {/* Broadcast from HQ Component */}
            <Route path="/broadcast-hq" element={
              <RequireAuth>
                <BroadcastFromHQ />
              </RequireAuth>
            } />
            
            {/* Catch-all route for unmatched paths */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </CreditsProvider>
      </HashRouter>
    </AuthProvider>
  );
}

export default App;
